var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#006AE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55563 12.5777V5.48682H9.32738V12.5777H8.55563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4858 7.84924L10.1008 8.48149L9.56925 6.00649L10.278 5.84674L10.5581 7.01899C10.5581 7.01899 11.2022 5.96261 10.3433 4.86799C9.837 4.30549 9.59681 4.28186 9.02925 4.19299C8.52975 4.12155 7.36875 4.2903 7.02281 5.64536C6.87656 6.51836 7.04137 7.16411 8.16637 8.00955L8.10337 8.95061C8.10337 8.95061 6.84731 8.0658 6.52331 7.44536C6.273 6.9543 5.84269 5.98455 6.61894 4.63455C7.03631 3.95955 7.85981 3.31211 9.3105 3.38018C10.0395 3.41055 11.8209 4.30268 11.5448 6.38505C11.4969 6.77543 11.2944 7.29518 11.2944 7.29518L12.2732 7.07749L12.4858 7.84924ZM11.124 13.3977C10.6875 14.0609 9.84712 14.6859 8.39981 14.5807C7.67025 14.5312 5.91469 13.5918 6.24544 11.5173C6.30337 11.1292 6.51994 10.6156 6.51994 10.6156L5.53613 10.8069L5.34375 10.0312L7.74563 9.46193L8.2125 11.9504L7.49813 12.0922L7.2495 10.9109C7.2495 10.9109 6.57787 11.9487 7.40644 13.067C7.89694 13.643 8.136 13.6722 8.70356 13.7757C9.19969 13.8612 10.3652 13.7217 10.7471 12.3768C10.9159 11.5089 10.7674 10.8581 9.66656 9.98168L9.75487 9.0423C9.75487 9.0423 10.9873 9.95918 11.2944 10.5886C11.5296 11.0881 11.9334 12.0697 11.124 13.3977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYfi);
export default __webpack_public_path__ + "static/media/yfi.82c956aa5e3c62981a52e57c2ddfebfe.svg";
export { ForwardRef as ReactComponent };